import $ from "@modules/jquery";

export default () => {
    $('ul.main-menu-investor-relations li.menu-item-has-children > a').on('click', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        var a = $(this);
        var content = $(this).parent().find('ul.sub-menu');
        if (!$(a).hasClass('active')) {
            $(content).slideUp();
            $(a).next().slideToggle();
            $(content).removeClass('active');
            $(a).addClass('active');
        } else {
            $(content).slideUp();
            $(a).removeClass('active');
        }
    })

};
